import React from "react";
import { Modal, Typography } from "antd";

const { Title } = Typography;

const ZellConfirmationModal = ({ open }) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      width={800}
      maskClosable={false}
      styles={{
        content: {
          borderRadius: 24,
          padding: "60px 40px",
          textAlign: "center",
        },
      }}
    >
      <Title
        level={1}
        style={{
          fontWeight: 800,
          letterSpacing: 4,
        }}
      >
        YOUR PAYMENT WILL BE PROCESSED
      </Title>
      <Title
        level={3}
        style={{
          marginTop: 20,
          letterSpacing: 3,
          fontWeight: 600,
        }}
      >
        You will be redirected automatically.
      </Title>
    </Modal>
  );
};

export default ZellConfirmationModal;